<template>
  <transition name="modal" ref="modal">
    <div class="cheetah-modal-overley" :class="{ 'is-visible' :  showteste === true }">
      <div class="cheetah-modal-mask" :class="{ 'is-visible' :  showteste === true, 'width-auto': width }" :style="{'width': width,'min-width': minWidth, 'height': height }" >
        <div class="modal-wrapper">

          <div class="cheetah-modal-header" :class="{'d-none': !header }">
            <slot name="header">
              {{ title }}
            </slot>
          </div>

          <div class="modal-container">
            <div class="cheetah-modal-body">
              <slot name="body">
                default body
              </slot>
            </div>
          </div>

          <div class="cheetah-modal-footer" :class="{'d-none': !header }">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: 'ModalComponent',
        props: ['title', 'show', 'width', 'minWidth', 'height', 'title', 'header', 'footer_none'],

        data(){
            return {
                showteste: false,
            }
        },

        methods: {
            showModal(){
              this.showteste = true;
            },

            open(){
              this.showteste = true;
            },

            close() {
                this.showteste = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

  .modal-wrapper {
    height: 100%;
    padding: 1.5rem 2rem;
  }

  .cheetah-modal-overley {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100010;
    font-size: 14px;
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    background: rgba(37, 37, 37, 0.9); // rgba(255, 255, 255, 0.9);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s;
    transform: translate3D(0, 0, 0);

    &.is-visible {
      visibility: visible;
      opacity: 1;
    }
  }

  .cheetah-modal-mask {
    // width: 80%;
    // height: 90%;
    // min-width: 320px;
    // max-width: 1596px;
    width: 900px;
    // height: 100%;
    // min-height: 200px;
    // max-height: 90%;

    &.width-auto{

    }

    box-sizing: border-box;
    background-color: #FFFFFF;
    box-shadow: 0px 14px 32px #00000040;
    // top: calc(90% / 2);
    // left: calc(80% / 2);

    position: relative;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;

    border-radius: 20px;
    // transform: scale(0.9) translate(calc(-50%), -50%);
    opacity: 0;
    transition-property: transform, opacity;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    transition-delay: 0.05s;
    transition-timing-function: cubic-bezier(0.52, 0.02, 0.19, 1.02);

    .modal-container {
      width: auto;
      display: flex;
      height: 100%;
    }
  }

  .cheetah-modal-mask.is-visible {
    // -webkit-transform: translate(-50%, -50%);
    // transform: translate(-50%, -50%);
    opacity: 1;
  }

  .cheetah-modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-top-left-radius: .3rem;
    border-top-right-radius: .3rem;
    color:#8E8989;
    font-size: 18px;
    font-weight: bold;
    padding: 0.5rem 0.5rem;

    .title-modal-member{
      color: #434343;
    }
  }

  .cheetah-modal-body {
    position: relative;
    flex: 1 1 auto;
    display: flex;
    overflow: auto;
    max-height: 450px;
    width: 100%;
    padding: 0.5rem 0.5rem;
  }

  .cheetah-modal-footer {
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // border-top: 1px solid #dee2e6;
    // border-bottom-right-radius: .3rem;
    // border-bottom-left-radius: .3rem;
    padding: 1.25rem 0rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/Modal.vue